import type {
  ParticipationReportGridColDef,
  ParticipationReportGridContext,
  ParticipationReportGridSetFilterValuesFunc,
} from '../../types';

export type Value = string | null | undefined;

export const setFilterValuesFunc: ParticipationReportGridSetFilterValuesFunc = ({
  success,
  context,
}) => {
  success((context as ParticipationReportGridContext).sectors.map(sector => sector.value));
};

export const sectorColDef: ParticipationReportGridColDef<Value> = {
  headerName: 'Sector',
  field: 'issuerSectorDisplayName',
  type: 'text',
  width: 143,
  sortable: true,
  filter: 'agSetColumnFilter',
  filterParams: {
    values: setFilterValuesFunc,
    valueFormatter: ({ value, context }) => {
      return context.sectors.find(sector => sector.value === value)?.label || value;
    },
  },
  floatingFilter: true,
  server: {
    filterFieldPath: 'issuerSector',
    sortFieldPath: 'issuerSector.displayName',
  },
};
